/* eslint-disable react/prop-types */
/**
 * Placeholder for per-pillar settings that don't have configurable knobs
 * yet.  Lives at /settings/{pillar}.  Wave-once removed when each pillar
 * grows real settings (lead stages for Sales, ticket SLAs for Service, etc.).
 *
 * Until then, this renders a clear "no pillar-specific settings yet" card
 * that points the user at Platform settings (where tenant-wide config
 * actually lives) — instead of a broken-looking empty page.
 */
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { EntityShell } from "../../components/shell";

export default function PillarPlaceholder({ pillar, title, description }) {
  return (
    <EntityShell kindLabel="Settings" title={title} backTo="/settings">
      <div className="space-y-4" data-testid={`settings-${pillar}-page`}>
        <div className="hv-card p-6" data-testid={`settings-${pillar}-placeholder`}>
          <h2 className="font-display text-xl font-bold text-[#dde3ec]">
            No pillar-specific settings yet
          </h2>
          <p className="text-sm text-[#a0aabf] mt-2 max-w-2xl leading-relaxed">
            {description} Tenant-wide configuration (integrations, taxonomy,
            data migration, feature flags) lives under Platform settings.
          </p>
          <Link
            to="/settings/platform"
            data-testid={`settings-${pillar}-platform-link`}
            className="hv-btn hv-btn-ghost text-xs mt-4 inline-flex"
          >
            Open Platform settings <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>
      </div>
    </EntityShell>
  );
}
